module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/calendar-e9f171f5d4edeeef68f0cf82e0fcd0e6.svg";